export { YouTubePlayer } from './YouTubePlayer'
